var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { BackrsIcon } from '@backrs_ui/common-ui/src/atoms/BackrsIcon';
import { Typography, Box } from '@mui/material';
export var NuggetPost = function (_a) {
    var variant = _a.variant;
    if (variant.type === 'LARGE') {
        var getHowManyDaysAgo = function (date) {
            var date1 = new Date(date);
            var date2 = new Date();
            var diffTime = Math.abs(date2.getTime() - date1.getTime());
            var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return "".concat(diffDays, " ").concat(appStrings.modules.nugget.textResponseDaysAgo);
        };
        return (_jsxs(Box, { onClick: variant.postUrl ? function () { return window.open(variant.postUrl, '_blank'); } : undefined, mt: 4, children: [_jsxs(Box, { position: "relative", sx: {
                        cursor: variant.postUrl ? 'pointer' : 'default',
                    }, children: [_jsx(Box, { sx: largeQuoteIconContainerStyle, children: _jsx(BackrsIcon, { name: "IconQuotationLarge", alt: "Quotation" }) }), _jsx(Typography, { variant: "body1", sx: bottomTextStyle, children: variant.text })] }), variant.userAbbreviatedName && (_jsxs(Box, { sx: __assign(__assign({}, imageHeadshotContainerStyle), { cursor: variant.linkToBackrsProfile ? 'pointer' : 'default' }), onClick: variant.linkToBackrsProfile
                        ? function () { return window.open(variant.linkToBackrsProfile, '_blank'); }
                        : undefined, children: [_jsx(Box, { sx: imageContainerStyle, children: variant.headshotImg ? (_jsx("img", { src: variant.headshotImg, alt: "".concat(variant.userAbbreviatedName, " headshot"), style: imageStyle, className: "ph-no-capture" })) : (_jsx(BackrsIcon, { name: "IconHeadshot", alt: "User", style: imageStyle })) }), _jsxs(Box, { children: [_jsx(Typography, { variant: "h6", mb: 0, children: variant.userAbbreviatedName }), variant.postDate && (_jsx(Typography, { variant: "body1", sx: postDateTextStyle, children: getHowManyDaysAgo(variant.postDate) }))] })] }))] }));
    }
    return variant.additionalQuote ? (_jsxs(Box, { sx: smallNuggetQuoteContainerStyle, children: [_jsxs(Box, { sx: additionalQuoteContainerStyle, children: [_jsx(BackrsIcon, { name: "IconQuotationLarge", alt: "Quotation", height: variant.contentSize === 'SMALL' ? 16 : 20, width: variant.contentSize === 'SMALL' ? 16 : 20 }), _jsx(Typography, { sx: additonalQuoteTextStyle, children: variant.additionalQuote })] }), variant.additionalQuoteAuthor && (_jsxs(Typography, { variant: "body1", alignSelf: 'flex-end', mt: 2, fontSize: '10pt', children: ["- ", variant.additionalQuoteAuthor] }))] })) : (_jsx(_Fragment, {}));
};
var largeQuoteIconContainerStyle = {
    position: 'absolute',
    right: 32,
    top: -28,
};
var imageHeadshotContainerStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
    gap: 2,
    mt: 4,
};
var additonalQuoteTextStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    width: '40ch',
    fontStyle: 'italic',
    fontSize: '10.5pt',
    lineHeight: 1.4,
};
var postDateTextStyle = {
    color: appColors.neutral.gray1,
    fontSize: 12,
    marginTop: 0,
};
var additionalQuoteContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: 1,
    justifyContent: 'flex-start',
};
var bottomTextStyle = {
    fontFamily: 'Sarabun',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    maxWidth: '100%',
    whiteSpace: 'pre-wrap',
    padding: 3,
    borderRadius: 4,
    backgroundColor: appColors.color.blue4,
};
var imageContainerStyle = {
    borderRadius: '50%',
    width: 72,
    height: 72,
    overflow: 'hidden',
};
var imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
};
var smallNuggetQuoteContainerStyle = {
    mt: 3,
    borderLeft: "4px solid ".concat(appColors.color.blue1),
    backgroundColor: appColors.color.blue4,
    padding: 2,
    flexDirection: 'column',
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'hidden',
};
